export interface LineReference {
  demandId: string;
  lineId: string;
}

export interface DocumentReference {
  demandId: string;
  documentId: string;
}

const safeSegment = /^[A-Za-z0-9_-]+$/;

export function lineReferenceHref(demandId: string, lineId: string): string {
  if (!safeSegment.test(demandId) || !safeSegment.test(lineId))
    throw new Error('Line reference ids must be URL-safe identifiers.');
  return `karwan://demand/${demandId}/line/${lineId}`;
}

export function parseLineReferenceHref(href: string): LineReference | undefined {
  const match = /^karwan:\/\/demand\/([A-Za-z0-9_-]+)\/line\/([A-Za-z0-9_-]+)$/.exec(href);
  return match?.[1] !== undefined && match[2] !== undefined ? { demandId: match[1], lineId: match[2] } : undefined;
}

export function lineReferenceMarkdown(
  demandId: string,
  lineId: string,
  lineNumber: number,
  description: string,
): string {
  const safeDescription = description
    .replaceAll('[', '(')
    .replaceAll(']', ')')
    .replaceAll('*', '∗')
    .replaceAll('`', "'")
    .replaceAll(/\s+/g, ' ')
    .trim();
  const label = `Line ${String(lineNumber)}: ${safeDescription}`;
  return `[${label}](${lineReferenceHref(demandId, lineId)})`;
}

export function documentReferenceHref(demandId: string, documentId: string): string {
  if (!safeSegment.test(demandId) || !safeSegment.test(documentId))
    throw new Error('Document reference ids must be URL-safe identifiers.');
  return `karwan://demand/${demandId}/document/${documentId}`;
}

export function parseDocumentReferenceHref(href: string): DocumentReference | undefined {
  const match = /^karwan:\/\/demand\/([A-Za-z0-9_-]+)\/document\/([A-Za-z0-9_-]+)$/.exec(href);
  return match?.[1] !== undefined && match[2] !== undefined ? { demandId: match[1], documentId: match[2] } : undefined;
}

export function documentReferenceMarkdown(demandId: string, documentId: string, filename: string): string {
  const label = filename
    .replaceAll('[', '(')
    .replaceAll(']', ')')
    .replaceAll('*', '∗')
    .replaceAll('`', "'")
    .replaceAll(/\s+/g, ' ')
    .trim();
  return `[${label}](${documentReferenceHref(demandId, documentId)})`;
}

export function isImageDocument(document: { filename: string; mimeType?: string | null }): boolean {
  return (
    (document.mimeType ?? '').startsWith('image/') ||
    /\.(png|jpe?g|gif|webp|heic|bmp|svg|tiff?)$/i.test(document.filename)
  );
}
